var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon icon-tabler icons-tabler-outline icon-tabler-lock-check",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 21h-4.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11v-4a4 4 0 1 1 8 0v4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19l2 2l4 -4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default __webpack_public_path__ + "static/media/permission.f04c54d8612fe27d5b8fda0efd1b2925.svg";
export { ForwardRef as ReactComponent };